module.exports = __webpack_public_path__ + "img/20.970a5c68.jpg";